import React, { useState, useEffect, useRef } from 'react';
import "./UserCreate.css"






const UserCreate = ({setShowCreate}) => {
  const [role, setRole] = useState('user');
  const [status, setStatus] = useState('active');

  const handleClose =()  => {
    setShowCreate(false);
  } 
  
  return (
    <div className="UserCreate_container">
    <form autocomplete="off">
      <div className="modal_title">
        <div>새로운 사용자 추가</div>
      </div>

      <div className="email">
        <label for="userEmail">이메일</label>
        <div className="email_input">
          <input
            type="email"
            name="email"
            id="userEmail"
            placeholder="이메일을 입력하세요"
          />
          <button id="btn_duplicate" type="button">Duplicate Check</button>
        </div>
      </div>

      <div className="password">
        <div>
          <label for="pw">비밀번호</label>
          <input
            type="password"
            name="password"
            id="pw"
            placeholder="비밀번호를 입력하세요"
          />
        </div>
        <div className="confirm_password">
          <label for="confirm_pw">비밀번호 확인</label>
          <input
            type="password"
            name="confirm_password"
            id="confirm_pw"
            placeholder="비밀번호를 입력하세요"
          />
        </div>
      </div>

      <div className="name">
        <label for="name">이름</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="이름을 입력하세요"
        />
      </div>

      <div className="phone">
        <label for="phone">전화번호</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          placeholder="전화번호를 입력하세요"
        />
      </div>

      <div className="Edituserinformation_ActivityContainer">
      <div className="Edituserinformation_AuthorityBox">
        권한
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className="custom-select"
        >
          <option value="user">일반 사용자</option>
          <option value="admin">관리자</option>
        </select>
      </div>

      <div className="Edituserinformation_ActivityBox">
        상태
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className={`custom-select ${
            status === 'active' ? 'active-text' : 'inactive-text'
          }`}
        >
          <option value="active">활성</option>
          <option value="inactive">비활성</option>
        </select>
      </div>
    </div>

      <div className="memo">
        <label for="note">메모</label>
        <textarea id="note" name="note"></textarea>
      </div>

      <div className="check">
        <div className="privacy">
          <p>개인정보 동의 여부 :</p>
          <input type="checkbox" name="privacy" id="privacy_agree" />
          <label for="privacy_agree">동의</label>
          <input type="checkbox" name="privacy" id="privacy_disagree" />
          <label for="privacy_disagree">미동의</label>
        </div>

        <div className="marketing">
          <p>마케팅 동의 여부 :</p>
          <input type="checkbox" name="marketing" id="marketing_agree" />
          <label for="marketing_agree">동의</label>
          <input type="checkbox" name="marketing" id="marketing_disagree" />
          <label for="marketing_disagree">미동의</label>
        </div>
      </div>
    </form>

    <div className="btn_modal">
      <button className="btn" type="submit">완료</button>
      <button className="btn" type="button" onClick={handleClose}>취소</button>
    </div>
  </div>

  )}

  export default UserCreate;
